<a href="mailto:{{ email }}">
  @if (displayText) {
    {{ displayText }}
  } @else {
    {{ email }}
  }
</a>
